// ---------------------------------------------------------------------------
// Where the API lives.
//
// One value, read by every screen. Previously nine files each declared their
// own `const API_BASE = "https://..."`, with another ninety-odd occurrences
// inlined into fetch calls — so pointing the app at a different server meant
// finding all of them, and missing one meant a screen that silently talked to
// the old backend while everything else had moved.
//
// Set REACT_APP_API_BASE in .env. Create React App reads it at BUILD time, not
// at runtime, so changing it needs a rebuild rather than a restart.
//
// The fallback is the delivery API on its own port, deliberately NOT the old
// pharmacy host: a forgotten .env should fail visibly against the right server
// rather than quietly succeed against the wrong one.
// ---------------------------------------------------------------------------

const API_BASE =
  process.env.REACT_APP_API_BASE || "http://194.76.27.167:3080";

export default API_BASE;
export { API_BASE };
